import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import CartCuttingDetails from '../Checkout/CartCuttingDetails';
import { currencyFormat, numberFormat } from '../../Services/formatting';
import { deleteSpecification } from '../../Actions/Cart.action';
import LoaderInlineContent from '../LoaderInlineContent';
import DeleteButton from '../CartGrid/DeleteButton';

const SpecificationDetailsRow = ({ item, specification, loading, showDeleteBtn }) => {
  const dispatch = useDispatch(),
    { cartSelections, rowSystemId, purchasedUnit } = item,
    { isCoilItem, blastingDetails } = cartSelections;

  const removeSpecificationRow = ({ id, lineId, lineDetails }) => {
    dispatch(deleteSpecification(id, lineId, lineDetails.inventoryLotId, rowSystemId));
  };

  return (
    <tr>
      <td>
        <details>
          <summary>
            {translate('checkout.cart.specification.selctionlength')} :{' '}
            {specification.length}{' '}
            {translate('checkout.cart.specification.selectionlengthmm')}
          </summary>
          <CartCuttingDetails
            isCoilItem={isCoilItem}
            specification={specification}
            blastingDetails={blastingDetails}
          />
        </details>
      </td>
      <td>
        {loading ? (
          <LoaderInlineContent length={6} />
        ) : (
          <Fragment>
            {numberFormat.format(specification.lineDetails ? specification.lineDetails.salesQuantity : 0)}{' '}
            {purchasedUnit}
          </Fragment>
        )}
      </td>
      <td>
        {loading ? (
          <LoaderInlineContent length={8} />
        ) : (
          <Fragment>
            {specification.lineDetails
              ? currencyFormat.format(specification.lineDetails.customerUnitPrice) : 0}
            {specification.lineDetails && specification.lineDetails.salesUnit && (
              <Fragment>
                {'/'}
                {translate('orderrow.' + specification.lineDetails.salesUnit)}
              </Fragment>
            )}
          </Fragment>
        )}
      </td>
      <td>
        {loading ? (
          <LoaderInlineContent length={10} />
        ) : (
          <Fragment>
            {specification.lineDetails ? specification.lineDetails.weight : 0}{' '}
            {translate('checkout.cart.specification.quantity.unit')}
          </Fragment>
        )}
      </td>
      <td className='specification-table__right-align-cell'>
        {loading ? (
          <LoaderInlineContent length={8} />
        ) : specification.lineDetails ? (
          currencyFormat.format(specification.lineDetails.customerNetPrice)
        ) : (
          0
        )}
      </td>
      <td className='specification-table__delete-cell'>
        {showDeleteBtn && (
          <DeleteButton
            inactive={loading}
            click={() => removeSpecificationRow(specification)}
          />
        )}
      </td>
    </tr>
  );
};

export default SpecificationDetailsRow;
